import dynamic from "next/dynamic";
import React from "react";
import { useAppContext } from "@components/Provider";
import { useTabletDetection } from "helpers/useTabletDetection";
import Sites from "../../constants/Sites";

import "./GlobalLayout1.css";
import CatalogHeader from "@components/HeaderPage/CatalogHeader";

//Dynamic import based on https://github.com/zeit/next.js/blob/canary/examples/with-dynamic-import/pages/index.js
// {/ Load immediately, but in a separate bundle / }
const Header = dynamic(() => import("../Header/Header"));
const Footer = dynamic(() => import("../Footer"));
const GoogleAdSenseDisplay = dynamic(() => import("../Ads/GoogleAdSenseDispalyAd"), { ssr: false });
const GoogleAdSense = dynamic(() => import("../Ads/GoogleAdSense"), {
  ssr: false,
});
const SheKnowsAd = dynamic(() => import("../Ads/SheKnowsAd"), { ssr: false });
const NewHeader = dynamic(() => import("../Header/NewHeader"), { ssr: false });
const ContentHeader = dynamic(() => import("../HeaderPage/ContentHeader"), {
  ssr: false,
});

const renderDisplayAd = (className, adnetwork, isMobile, displayResponsiveAd) => {
  if (!isMobile) {
    return (
      <React.Fragment>
        <div className={className}>
          {adnetwork === "SheKnows" ? (
            displayResponsiveAd ? (
              <SheKnowsAd type={"medrec"} />
            ) : (
              <SheKnowsAd type={"banner"} />
            )
          ) : displayResponsiveAd ? (
            <GoogleAdSense />
          ) : (
            <GoogleAdSenseDisplay />
          )}
        </div>
        <style>
          {`
            .topad_singleColumnWithAds {
              padding-top: 78px;
              text-align: center;
              padding-bottom: 2px;
              border-bottom: 1px solid black;
            }
            .paddingTop_singleColumnWithAds {
              padding-top: 75px;
            }
            .bottomad_singleColumnWithAds {
              text-align: center;
              padding-bottom: 5px;
              padding-top: 7px;
              border-top: 1px solid black;
            }
            @media only screen and (min-width: 320px) and (max-width: 767px) {
              .paddingTop_singleColumnWithAds {
                padding-top: 125px;
              }
            }
          `}
        </style>
      </React.Fragment>
    );
  }
};

const SingleColumnLayoutWithAds = (props) => {
  const {
    data,
    siteId,
    isMobile,
    isTablet: serverIsTablet,
    subscriberCookie,
    isNonClosableModalChecked,
  } = useAppContext() || {};

  // Enhanced client-side tablet detection using custom hook
  const { isTablet } = useTabletDetection(serverIsTablet, isMobile);

  let adnetwork = data.SiteSettings.ad_settings.adnetwork,
    topAdPadding = props.isHeader == true ? "paddingTop_singleColumnWithAds" : "";
  // Part of older EBB homepage. See https://openroadmedia.atlassian.net/browse/ORMTECH-1810
  // let isHeader =
  //   siteId == Sites.EARLYBIRDBOOKS
  //     ? router.asPath == "/"
  //       ? isMobile
  //         ? true
  //         : false
  //       : true
  //     : true;
  let isHeader = siteId == Sites.EARLYBIRDBOOKS ? false : true;

  return (
    <React.Fragment>
      {isHeader ? (
        <>
          <Header isNonClosableModalChecked={isNonClosableModalChecked} />
          {!isMobile &&
            (siteId === Sites.OPENROADMEDIA ? (
              <CatalogHeader />
            ) : (
              <ContentHeader isMobile={isMobile} isTablet={isTablet} />
            ))}
        </>
      ) : (
        <NewHeader />
      )}
      <div
        className={
          props.containerWithMargin
            ? "layout_container containerWithMargin_singleColumnWithAds"
            : `layout_container ${siteId != Sites.OPENROADMEDIA ? "containerWithMargin_SingleColumnWithAds" : ""}`
        }
        style={{
          "--top-padding-1024": !subscriberCookie ? "58px" : "15px",
          "--top-padding-712": !subscriberCookie
            ? siteId == Sites.EARLYBIRDBOOKS
              ? "0"
              : "15px"
            : "15px",
        }}
      >
        {/* {/ Don't display header ad for mobile  /} */}
        <div>
          {renderDisplayAd(
            `topad_singleColumnWithAds container_singleColumnWithAds ${topAdPadding}`,
            adnetwork,
            isMobile
          )}
        </div>
        <div className="container_singleColumnWithAds noTopAd_singleColumnWithAds">
          {props.children}
        </div>
        {renderDisplayAd(
          "bottomad_singleColumnWithAds container_singleColumnWithAds",
          adnetwork,
          false,
          true
        )}
      </div>
      <Footer />
      <style>
        {`
          .container_singleColumnWithAds {
            display: flex;
            margin: ${props.fullWidth ? "0" : "1rem"};
            justify-content: center;
          }
          .noContainerMargin {
            display: flex;
            justify-content: center;
          }
          .containerWithMargin_singleColumnWithAds {
            margin: 0 5rem;
          }
          .containerWithMargin_singleColumnWithAds .container_singleColumnWithAds {
            margin: 1rem 0;
          }
          @media only screen and (min-width: 320px) and (max-width: 767px) {
            .container_singleColumnWithAds {
              flex-direction: column;
            }
            .noTopAd_singleColumnWithAds {
              padding-top: 40px;
            }
          }

          @media (min-width: 768px) {
            .noTopAd_singleColumnWithAds {
              padding-top: 0;
            }
          }
          @media (max-width: 991px) {
            .containerWithMargin_singleColumnWithAds {
              margin: 0 1rem;
            }
          }
          @media (max-width: 767px) {
            .containerWithMargin_singleColumnWithAds {
              margin: 0;
            }
          }
          @media only screen and (min-width: 812px) and (orientation: landscape) and (max-width: 1023px),
            (min-device-width: 414px) and (max-device-height: 896px) and (-webkit-device-pixel-ratio: 3),
            (max-device-width: 767px) and (-webkit-device-pixel-ratio: 2) {
            .container_singleColumnWithAds {
              flex-direction: column;
              padding-top: ${!subscriberCookie ? (siteId == Sites.OPENROADMEDIA ? "30px" : "52px") : "15px"};
            }
          }

          @media (min-width: 712px) and (max-width: 712px) {
            .noTopAd_singleColumnWithAds {
              padding-top: ${siteId == Sites.EARLYBIRDBOOKS ? "0px" : "15px"};
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default SingleColumnLayoutWithAds;
